import { api } from "..";
const endpoint = "/api/inbounds";

export const getInboundList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getInboundById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createInbound = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateInbound = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteInbound = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const updateInboundStatus = async (id, status) => {
  return await api.post(`${endpoint}/${id}/changeStatus`, JSON.stringify(status));
}; 